export default __webpack_public_path__ + "270fd0bde578e2e4a600c78b46952799.png";